// @generated by c1gen-ts
// tslint:disable

// Quota reference enum values

export const QuotaRefTenantMaxBulkActionsForOneAction = 16
export const QuotaRefTenantAccessProfileRemovedMembersThresholdPercent = 44
export const QuotaRefTenantAccessProfileMinCatalogMembers = 45

export type QuotaRef = 
  16
  | 44
  | 45

// Default quota values
export const DefaultQuotas: Record<QuotaRef, number> = {
  [QuotaRefTenantAccessProfileRemovedMembersThresholdPercent]: 20,
  [QuotaRefTenantAccessProfileMinCatalogMembers]: 100,
  [QuotaRefTenantMaxBulkActionsForOneAction]: 5000,
}
